
import Vue from 'vue'

interface Feature {
  icon: string
  tone: string
  title: string
  text: string
}

interface Step {
  icon: string
  title: string
  text: string
}

interface GalleryItem {
  src: string
  alt: string
  label: string
  title: string
  text: string
}

export default Vue.extend({
  name: 'TokKidsPage',

  metaInfo: {
    meta: [
      {
        vmid: 'og:image',
        property: 'og:image',
        content: 'https://www.ari.company/games/tok-kids/assets/tok-kids-games.webp'
      },
      {
        vmid: 'og:type',
        property: 'og:type',
        content: 'website'
      },
      {
        vmid: 'twitter:card',
        name: 'twitter:card',
        content: 'summary_large_image'
      }
    ]
  },

  data () {
    return {
      features: [
        {
          icon: '⚑',
          tone: 'blue',
          title: 'Adventure-based learning',
          text: 'Typing exercises become missions with characters, challenges, rewards, and visible progress.'
        },
        {
          icon: 'ABC',
          tone: 'purple',
          title: 'Letters, words, speed, and accuracy',
          text: 'Children practise essential keyboard skills through focused activities and different mission types.'
        },
        {
          icon: '★',
          tone: 'gold',
          title: 'Progress that feels rewarding',
          text: 'Mission completion, badges, rewards, and adventure progress give children a clear reason to continue.'
        },
        {
          icon: '◎',
          tone: 'green',
          title: 'Child-friendly focus',
          text: 'Clear interactions, friendly visuals, and minimal distractions help children concentrate on the next word and the next goal.'
        }
      ] as Feature[],
      steps: [
        {
          icon: '♞',
          title: 'Choose a hero',
          text: 'Start the journey with a friendly character.'
        },
        {
          icon: '⌨',
          title: 'Complete typing missions',
          text: 'Turn letters and words into clear objectives.'
        },
        {
          icon: '↗',
          title: 'Improve accuracy and speed',
          text: 'Build confidence one completed word at a time.'
        },
        {
          icon: '✦',
          title: 'Unlock progress and rewards',
          text: 'See each effort move the adventure forward.'
        }
      ] as Step[],
      gallery: [
        {
          src: '/games/tok-kids/assets/tok-kids-adventure-map.jpg',
          alt: 'Tok.Kids fantasy adventure map with a winding route, mission checkpoints, castle, and treasure',
          label: '01 · Adventure',
          title: 'A journey with direction',
          text: 'A clear map turns practice into an adventure with a visible next destination.'
        },
        {
          src: '/games/tok-kids/assets/tok-kids-typing-challenge.jpg',
          alt: 'Tok.Kids typing challenge with a child hero, keyboard, word tiles, progress stars, and friendly creature',
          label: '02 · Gameplay',
          title: 'Words that move the story',
          text: 'Typing challenges connect each key press to progress inside the game world.'
        },
        {
          src: '/games/tok-kids/assets/tok-kids-rewards.jpg',
          alt: 'Tok.Kids treasure chest, stars, coins, and achievement rewards in a fantasy setting',
          label: '03 · Progress',
          title: 'Rewards worth reaching',
          text: 'Stars, milestones, and rewards make effort visible without distracting from practice.'
        }
      ] as GalleryItem[],
      focusPoints: [
        'Short, understandable objectives',
        'Visible mission progress',
        'Different typing challenges',
        'Immediate visual feedback',
        'Continued player progress'
      ] as string[]
    }
  }
})
